let loadingCounter = 0;

export class DatasourceLoaderStateService {
  public static increaseLoadingCounter() {
    loadingCounter++;
  }

  public static decreaseLoadingCounter() {
    if (loadingCounter > 0) {
      loadingCounter--;
    }
  }

  public static getLoadingCounter() {
      return loadingCounter;
  }

  public static resetLoadingCounter() {
    loadingCounter = 0;
  }
}